export default "skymp5-front/e59d5bbc14f4a2335a19deef3669797c.gif";